<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <table style="width:100%" class="table-form-details">
          <colgroup>
            <col style="width:30%">
            <col style="width:70%">
          </colgroup>
          <tr>
            <td><strong>File Name:</strong> </td>
            <td>{{ data.name }}</td>
          </tr>
          <tr>
            <td><strong>Folder:</strong></td>
            <td>{{ data.path }}</td>
          </tr>
          <tr>
            <td><strong>Uploaded By:</strong></td>
            <td>{{ getUserDisplayName(data.uploadedBy) }}</td>
          </tr>
          <tr>
            <td><strong>Uploaded On: </strong></td>
            <td>{{ data.createdAt | formatDate }}</td>
          </tr>
          <tr>
            <td><strong>Last Used: </strong></td>
            <td>{{ data.lastUsedAt | formatDate }}</td>
          </tr>
          <tr>
            <td><strong>Download count: </strong></td>
            <td>{{ data.downloadCount }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;" v-if="showTaskNames">
      <div class="col-md-12">
        <h6>Task Names Using This Form</h6>
        <el-table class="table-striped"
                  :data="taskNames"
                  :show-header="false"
                  row-key="id"
                  border
                  style="width: 100%">
          <el-table-column prop="name" label="Task Names">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {OK} from 'http-status-codes'
  import Constants from 'src/utilities/constants'

  export default {
    props: ['data'],
    data() {
      return {
        showTaskNames: false,
        taskNames: []
      }
    },
    methods: {
      getUserDisplayName(userId) {
        return this.$store.getters['users/displayName'](userId)
      }
    },
    async mounted() {
      if (this.data && this.data.path === Constants.FOLDERS.INSPECTION_FORMS) {
        this.showTaskNames = true
        const response = await this.$store.dispatch('tasks/names/taskNamesByFileId', this.data.id)
        if (OK === response.status) {
          this.taskNames = response.data
          this.$forceUpdate()
        }
      }
    },
    destroyed() {
      this.showTaskNames = false
    }
  }
</script>

<style scoped>
  .table-header {
    font-weight: bold;
  }
  .table-form-details tr {
    height: 25px;
    border-bottom: 1px solid #d3dce6;
  }
</style>
